import { render, staticRenderFns } from "./FormWrap.vue?vue&type=template&id=327a8729&scoped=true&"
import script from "./FormWrap.vue?vue&type=script&lang=ts&"
export * from "./FormWrap.vue?vue&type=script&lang=ts&"
import style0 from "./FormWrap.vue?vue&type=style&index=0&id=327a8729&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a8729",
  null
  
)

export default component.exports